import { CONTACT_API } from 'modules/contacts/api/contact-api'
import {
  ContactEmailsApiInterface,
  ContactEmailsFilterType,
} from 'modules/contacts/contact-page/types/contact-emails-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'
import { ContactId } from '../../types/contact-interface'

interface UseContactEmailsInterface extends SwrPaginationInterface {
  filter: ContactEmailsFilterType
  contactId: ContactId
  shouldFetch: boolean
  needCounter?: boolean
}

export function useContactEmails({
  limit,
  pagination,
  filter,
  contactId,
  shouldFetch,
  needCounter,
}: UseContactEmailsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactEmailsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${
    filter.date && filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ''
  }${filter.date && filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ''}${
    filter.searchBy && filter.searchBy !== ''
      ? `&filter[searchBy]=${encodeURIComponent(filter.searchBy)}`
      : ''
  }`

  const { data: contactEmails, mutate } = useSWR(() => {
    if (user && shouldFetch && pagination.startFromId === undefined && limit) {
      return `${CONTACT_API}/contacts/${contactId}/emails/list?pagination[limit]=${limit}${filterApi}`
    } else if (user && shouldFetch && pagination.startFromId && limit) {
      return `${CONTACT_API}/contacts/${contactId}/emails/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
    }
    return null
  }, fetcher)

  const { data: counter } = useSWR<CountInterface>(() => {
    if (user && needCounter) {
      return `${CONTACT_API}/contacts/${contactId}/emails/count?${filterApi}`
    }
    return null
  }, baseFetcher)

  return { contactEmails, mutate, counter }
}
